
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manufacturers",
      function () {
        return require("private-next-pages/manufacturers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manufacturers"])
      });
    }
  